import { useState } from "react";
import { Button, DialogActions, DialogContent } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { getCurrentDateMask, getCurrentInputFormat, toSameDateTimeUTC } from "../../../utils/dateTimeFormat";
import { accessKeys, hasSomeAccess } from "../../../utils/userAccess";
import Translate from "../../../utils/Translate";

export default function ChangeLicenseDateDialog({ actorId, licensesByActorId, handleUpdateLicense }) {
  const [date, setDate] = useState(licensesByActorId[actorId].date);

  function handleOk() {
    handleUpdateLicense(actorId, toSameDateTimeUTC(date), false, true);
    window.history.back();
  }

  return (
    <>
      <DialogContent>
        <DatePicker
          displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
          disabled={licensesByActorId[actorId].isLocked}
          mask={getCurrentDateMask()}
          format={getCurrentInputFormat()}
          label={Translate.get("LicenseDate")}
          value={date}
          onChange={(newDate, context) => {
            if (newDate && !context.validationError) {
              setDate(newDate);
            }
          }}
          sx={{ width: "100%", marginTop: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.history.back()}>{Translate.get("Cancel")}</Button>
        <Button variant="contained" onClick={handleOk} disabled={!date}>
          {Translate.get("Ok")}
        </Button>
      </DialogActions>
    </>
  );
}
